import { render, staticRenderFns } from "./html.vue?vue&type=template&id=6c97f681&scoped=true&"
import script from "./html.vue?vue&type=script&lang=ts&"
export * from "./html.vue?vue&type=script&lang=ts&"
import style0 from "./html.vue?vue&type=style&index=0&id=6c97f681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97f681",
  null
  
)

export default component.exports